import './App.css'
import '../src/assets/scss/main.css'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { Suspense, lazy } from 'react'
import Loader from './components/Loader'
import ScrollToTop from './components/ScrollToTop'
import CloudBackbone from './pages/CloudBackbone'

// Lazy imports
const Home = lazy(() => import('./pages/Home'))
const Login = lazy(() => import('./pages/Login'))
const CreateAccount = lazy(() => import('./pages/CreateAccount'))
const Cluster = lazy(() => import('./pages/Cluster'))
const Node = lazy(() => import('./pages/Node'))
const Applications = lazy(() => import('./pages/Applications'))
const LoadBalancer = lazy(() => import('./pages/LoadBalancer'))
const ListCluster = lazy(() => import('./pages/ListCluster'))
const ListNode = lazy(() => import('./pages/ListNode'))
const ListApplications = lazy(() => import('./pages/ListApplication'))
const ListLoadBalancer = lazy(() => import('./pages/ListLoadBalancer'))
const Project = lazy(() => import('./pages/Project'))
const ViewProject = lazy(() => import('./pages/ViewProject'))
const Listproject = lazy(() => import('./pages/Listproject'))
const Deployment = lazy(() => import('./pages/Deployment'))
const Contact = lazy(() => import('./pages/Contact'))
const Log = lazy(() => import('./pages/Log'))
const TechProfile = lazy(() => import('./pages/TechProfile'))
const CreateProfile = lazy(() => import('./pages/CreateProfile'))
const TechEditProfile = lazy(() => import('./pages/TechEditProfile'))
const TechViewProfile = lazy(() => import('./pages/TechViewProfile'))
const EditProfile = lazy(() => import('./pages/EditProfile'))
const DeploymentLambda = lazy(() => import('./pages/DeploymentLambda'))
const ConfigureLambda = lazy(() => import('./pages/ConfigureLambda'))
const Aws = lazy(() => import('./pages/Aws'))
const Azure = lazy(() => import('./pages/Azure'))
const UpdateProject = lazy(() => import('./pages/UpdateProject'))
const Vps = lazy(() => import('./pages/Vps'))
const Kubernetes = lazy(() => import('./pages/Kubernetes'))
const Gcp = lazy(() => import('./pages/Gcp'))
const Introduction = lazy(() => import('./pages/introduction'))
const AzureProfile = lazy(() => import('./pages/AzureProfile'))
const CreateMuleSoft = lazy(() => import('./pages/CreateMuleSoft'))
const KubernetesPowers = lazy(() => import('./pages/KubernetesPowers'))
const KubernetesVps = lazy(() => import('./pages/KubernetesVPS'))
const Cloudbackbone = lazy(() => import('./pages/CloudBackbone'))
const Understandingcloud = lazy(() => import('./pages/Understandingcloud'))
const Awseks = lazy(() => import('./pages/Awseks'))
const About = lazy(() => import('./pages/About'))
const ProfileAdmin = lazy(() => import('./pages/admin/ProfileAdmin'))
const AdminAuth = lazy(() => import('./pages/admin/AdminAuth'))
const AdminBlog = lazy(() => import('./pages/admin/AdminBlog'))
const AdminBlogList = lazy(() => import('./pages/admin/AdminBlogList'))
const AdminEditblog = lazy(() => import('./pages/admin/AdminEditblog'))
const Blogs = lazy(() => import('./pages/Blogs'))
const ViewBlog = lazy(() => import('./pages/ViewBlog'))
const Migrate = lazy(() => import('./pages/Migrate'))
const ListMigrate = lazy(() => import('./pages/ListMigrate'))
const SingleMigrate = lazy(() => import('./pages/SingleMigrate'))
// Migrated projects: View shows the generated code, Edit changes it and commits (List Projects → eye / pen)
const MigrateViewProject = lazy(() => import('./pages/MigrateViewProject'))
const MigrateEditProject = lazy(() => import('./pages/MigrateEditProject'))
const Presentation = lazy(() => import('./pages/presentation/Presentation'))
const DevPresentation = lazy(() =>
  import('./pages/presentation/DevPresentation')
)
const DockerProfile = lazy(() => import('./pages/DockerProfile'))
const LLMProfile = lazy(() => import('./pages/LLMProfile'))
const EditLLMProfile = lazy(() => import('./pages/EditLLMProfile'))
const EditAzureProfile = lazy(() => import('./pages/EditAzureProfile'))
const EditDockerProfile = lazy(() => import('./pages/EditDockerProfile'))
const AwsLambda = lazy(() => import('./pages/applications/AwsLambda'))
const AwsAPI = lazy(() => import('./pages/applications/AwsAPI'))
const AazureAPI = lazy(() => import('./pages/azuregateway/AzureApi'))
const DeploymentAzure = lazy(() => import('./pages/DeploymentAzure'))
const AddLambdaApi = lazy(() => import('./pages/applications/AddLambdaApi'))
const AddAzureApi = lazy(() => import('./pages/azuregateway/AddAzureApi'))
const EditLambdaApi = lazy(() => import('./pages/applications/EditLambdaApi'))
const LogfilesView = lazy(() => import('./pages/applications/LogfilesView'))
const APIManagementAPIM = lazy(() => import('./pages/apim'))
const APIManagementList = lazy(() => import('./pages/azuregateway/ApimTech'))
const AwsApplication = lazy(() => import('./pages/applications/AwsApplication'))
const ProjectUpdate = lazy(() => import('./pages/ProjectUpdate'))
const Onboarding = lazy(() => import('./pages/Onboarding'))
const GithubRepoConfig = lazy(() => import('./pages/GithubRepoConfig'))
const GithubProfile = lazy(() => import('./pages/GithubProfile'))
const AzureApplications = lazy(() =>
  import('./pages/applications/AzureApplications')
)
const ConfigurePolicy = lazy(() =>
  import('./pages/applications/ConfigurePolicy')
)
const AzureApiApplication = lazy(() =>
  import('./pages/applications/AzureApiApplication')
)
const CodeQuality = lazy(() =>
  import('./pages/CodeQuality')
)

const FolderProject = lazy(() =>
  import('./pages/FolderProject')
)

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/login' element={<Login />} />
          <Route path='/createaccount' element={<CreateAccount />} />
          <Route path='/cluster' element={<Cluster />} />
          <Route path='/node' element={<Node />} />
          <Route path='/applications' element={<Applications />} />
          <Route path='/loadbalancer' element={<LoadBalancer />} />
          <Route path='/listcluster' element={<ListCluster />} />
          <Route path='/listnode' element={<ListNode />} />
          <Route path='/githubprofile/:id' element={<GithubProfile />} />
          <Route path='/listapplications' element={<ListApplications />} />
          <Route path='/listloadbalancer' element={<ListLoadBalancer />} />
          <Route path='/github-repo-config' element={<GithubRepoConfig />} />
          <Route path='/project' element={<Project />} />
          <Route path='/listproject' element={<Listproject />} />
          <Route path='/deployment' element={<Deployment />} />
          <Route path='/viewproject/:id' element={<ViewProject />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/logs/:pod/:masterip/:appname/*' element={<Log />} />
          <Route path='/techprofile' element={<TechProfile />} />
          <Route path='/createprofile' element={<CreateProfile />} />
          <Route path='/llmprofile' element={<LLMProfile />} />
          <Route path='/llmprofile/:id' element={<EditLLMProfile />} />
          <Route path='/azureprofile' element={<AzureProfile />} />
          <Route path='/techeditprofile/:id' element={<TechEditProfile />} />
          <Route path='/check-code-quality/:name' element={<CodeQuality />} />
          <Route path='/project/update' element={<ProjectUpdate />} />
          <Route path='/techviewprofile/:id' element={<TechViewProfile />} />
          <Route path='/editprofile' element={<EditProfile />} />
          <Route path='/deploymentlambda' element={<DeploymentLambda />} />
          <Route path='/configure-lambda/:id' element={<ConfigureLambda />} />
          <Route path='/aws' element={<Aws />} />
          <Route path='/azure' element={<Azure />} />
          <Route path='/deploymentazure' element={<DeploymentAzure />} />
          <Route path='/vps' element={<Vps />} />
          <Route path='/kubernetes' element={<Kubernetes />} />
          <Route path='/gcp' element={<Gcp />} />
          <Route path='/introduction' element={<Introduction />} />
          <Route path='/api-management-apim' element={<APIManagementAPIM />} />
          <Route path='/create-mulesoft' element={<CreateMuleSoft />} />
          <Route path='/azure/azure-api-management' element={<AazureAPI />} />
          <Route path='/update-poject/:id' element={<UpdateProject />} />
          <Route path='/onboarding' element={<Onboarding />} />
          <Route
            path='/how-kubernetes-powers-cloud-clusters'
            element={<KubernetesPowers />}
          />
          <Route path='/kubernetes-on-vps' element={<KubernetesVps />} />
          <Route path='/cloud-backbone' element={<Cloudbackbone />} />
          <Route path='/understanding-cloud' element={<Understandingcloud />} />
          <Route path='/aws-eks' element={<Awseks />} />
          <Route path='/about-us' element={<About />} />
          <Route path='/admin/profile' element={<ProfileAdmin />} />
          <Route path='/admin-auth' element={<AdminAuth />} />
          <Route path='/admin/blog' element={<AdminBlog />} />
          <Route path='/admin/listblog' element={<AdminBlogList />} />
          <Route path='/admin/editblog/:id' element={<AdminEditblog />} />
          <Route path='/azureprofile/:id' element={<EditAzureProfile />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/view-blog/:id' element={<ViewBlog />} />
          <Route path='/migrate' element={<Migrate />} />
          <Route path='/listmigrate' element={<ListMigrate />} />
          <Route path='/singlemigrate/:id' element={<SingleMigrate />} />
          <Route path='/migrate/view/:id' element={<MigrateViewProject />} />
          <Route path='/migrate/edit/:id' element={<MigrateEditProject />} />
          <Route path='/presentation' element={<Presentation />} />
          <Route path='/dev-presentation' element={<DevPresentation />} />
          <Route path='/docker-profile' element={<DockerProfile />} />
          <Route path='/docker-profile/:id' element={<EditDockerProfile />} />
          <Route path='/applications/awslambda' element={<AwsLambda />} />
          <Route path='/applications/aws-api' element={<AwsAPI />} />
          <Route path='/applications/azure' element={<AzureApplications />} />
          <Route
            path='/applications/azure-applications'
            element={<AzureApiApplication />}
          />
          <Route path='/folder/:projectname' element={<FolderProject />} />
          <Route
            path='/applications/aws-applications'
            element={<AwsApplication />}
          />

          <Route path='/applications/lambda-api' element={<AddLambdaApi />} />
          <Route path='/azure/azure-api' element={<AddAzureApi />} />
          <Route path='/azure/azure-apim' element={<APIManagementList />} />

          <Route
            path='/applications/logs/:apiname/:project'
            element={<LogfilesView />}
          />
          <Route
            path='/applications/configure-policy/:apiId/:stageName'
            element={<ConfigurePolicy />}
          />
          <Route
            path='/applications/Edit-lambda-api/:apiname/:project'
            element={<EditLambdaApi />}
          />
        </Routes>
      </Suspense>
    </Router>
  )
}

export default App
